import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

const handlePrepareData = ({
  name, type, active, duration
}) => ({
  name,
  type_id: type.key,
  active,
  duration
});

const Legs = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminAvailabilities()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.availabilityLeg,
      list: REDUCER_KEY.availabilityLegs
    }}
    config={config}
    onPrepareData={handlePrepareData}
    permissions={permissions}
  />
);

Legs.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default Legs;
